import { indentation } from './indentation';
import { stratify, hierarchy } from 'd3';

// The column that stores the origin value.
const ORIGIN = 'Ethnic Origin';
const RELIGION = 'Total';

const THRESHOLD = 150;

// These functions act as filters for various levels
// of the origin and religion hierarchies.
const topLevel = key => indentation(key) === 1;
const twoLevels = key => indentation(key) === 1 || indentation(key) === 2;
const allLevelsExceptTotal = key => indentation(key) !== 0;
const allLevels = () => true;
//const allLevels = key => indentation(key) <= 2;

const stratifyNodes = stratify()
.id(d => d.name)
.parentId(d => d.parent);

const computeNodes = names => {
  const lastSeenAtLevel = {};
  let i = 0;
  return names.map(name => {
    const level = indentation(name);
    lastSeenAtLevel[level] = name;
    const parent = lastSeenAtLevel[level - 1];
    i += 1;
    return { name, parent, i };
  });
};

// Transforms the raw data into the form required by d3.sankey.
export function transformData(data) {
  // Tweak these to see different levels of the hierarchies.
  const isValidReligion = key => allLevels(key) && key !== ORIGIN;
  const isValidOrigin = allLevels;

  const religions = Object.keys(data[0]).filter(isValidReligion);
  let origins = data.map(d => d[ORIGIN]).filter(isValidOrigin);

  let originNodes = computeNodes(origins);
  let religionNodes = computeNodes(religions);

  const originHierarchy = hierarchy(stratifyNodes(originNodes));
  const religionHierarchy = hierarchy(stratifyNodes(religionNodes));

  let data_dict = {};
  for (let i = 0; i < data.length; i++) {
    data_dict[data[i][ORIGIN]] = data[i];
  }

  let links = [];
  let root_origins = [];
  let religion_data = {}

  for (let i = 0; i < data.columns.length; i++) {
    let v = 0;
    originHierarchy.eachBefore((n) => {
      if (n.height === 0) {
        v += +data_dict[n.data.data.name][data.columns[i]];
      }
    });
    religion_data[data.columns[i]] = v;
  }

  originHierarchy.eachBefore((n) => {
    n.data.data.originalHeight = n.height;
    n.data.data.originalDepth = n.depth;
    n.data.data.type = 'origin';
    if (n.depth <= 1) {
      n.data.data.root = n.data.data.name;
    } else {
      n.data.data.root = n.parent.data.data.root;
    }
  });

  religionHierarchy.eachBefore((n) => {
    n.data.data.originalHeight = n.height;
    n.data.data.originalDepth = n.depth;
    n.data.data.type = 'religion';
    if (n.depth <= 1) {
      n.data.data.root = n.data.data.name;
    } else {
      n.data.data.root = n.parent.data.data.root;
    }
  });

  for (var h = 0; h < 5; h++) {
    originHierarchy.eachBefore((n) => {
      if (n.height === h) {
        let v = +data_dict[n.data.data.name][RELIGION];
        if (n.height > 0) {
          v = 0;
          for (let i = 0; i < n.children.length; i++) {
            v += +data_dict[n.children[i].data.data.name][RELIGION];
          }
          data_dict[n.data.data.name][RELIGION] = v;
        } else {
          root_origins.push({name: n.data.data.name, root: n.data.data.root});
        }

        if (v > 0 && n.depth > 1) {
          links.push({
            target: n.data.data.name,
            source: n.parent.data.data.name,
            value: v,
            root: n.data.data.root
          })
        }
      }
    });
  }

  let nodes_to_keep = [];
  let total_nodes = [];

  religionHierarchy.eachBefore((n) => {
    if (n.height == 0) {
      for (let o = 0; o < root_origins.length; o++) {
        let v = data_dict[root_origins[o].name][n.data.data.name];
        total_nodes.push(root_origins[o].name);
        total_nodes.push(n.data.data.name);
        if (v > THRESHOLD) {
          links.push({
            source: root_origins[o].name,
            target: n.data.data.name,
            value: v,
            root: root_origins[o].root + "-" + n.data.data.root
          });
          nodes_to_keep.push(root_origins[o].name);
          nodes_to_keep.push(n.data.data.name);
        }
      }
    }
  });

  for (var h = 0; h < 5; h++) {
    religionHierarchy.eachBefore((n) => {
      if (n.height === h) {
        let v = +religion_data[n.data.data.name];
        if (n.height > 0) {
          v = 0;
          for (let i = 0; i < n.children.length; i++) {
            v += +religion_data[n.children[i].data.data.name];
          }
          religion_data[n.data.data.name] = v;
        } else {
          root_origins.push(n.data.data.name);
        }

        if (n.depth > 1) {
          links.push({
            source: n.data.data.name,
            target: n.parent.data.data.name,
            value: v,
            root: n.data.data.root
          });
        }
      }
    });
  }

  originNodes = originNodes.slice(1, originNodes.length);
  religionNodes = religionNodes.slice(1, religionNodes.length);

  let nodes_to_remove = Array.from(new Set(total_nodes.filter((n) => nodes_to_keep.indexOf(n) < 0)));

  originNodes = originNodes.filter((n) => nodes_to_remove.indexOf(n.name) < 0);
  religionNodes = religionNodes.filter((n) => nodes_to_remove.indexOf(n.name) < 0);
  links = links.filter((l) => !((nodes_to_remove.indexOf(l.source) >= 0) || (nodes_to_remove.indexOf(l.target) >= 0)));

  const nodes = originNodes.concat(religionNodes);

  return {
    nodes,
    links
  };
}



// WEBPACK FOOTER //
// ./src/Sankey/transformData.js